


















import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_createCreditNote } from '@/queries/__generated__/createCreditNote';
import { GQL_invoice_invoice } from '@/queries/__generated__/invoice';
import i18n from '@/i18n';
import gql from 'graphql-tag';

const CREATE_CREDIT_NOTE = gql`
  mutation createCreditNote($invoiceId: ID!) {
    createCreditNote(
      input: {
        invoiceId: $invoiceId,
      }
    ) {
      orders {
        id
        number
      }
    }
  }
`;

@Component
export default class CreditNoteButton extends Vue {
  @Prop() public invoice!: GQL_invoice_invoice;
  private loading = false;

  public makeCreditNote() {
    this.$sMessage.info(this.$t('Message.processing'), { duration: 1000 });
    this.loading = true;

    this.$apollo.mutate({
      mutation: CREATE_CREDIT_NOTE,
      variables: {
        invoiceId: this.invoice.id,
      },
    }).then(({ data }) => {
      this.redirectToCreated(data);
    }).finally(() => {
      this.loading = false;
    });
  }
  private confirmCreate() {
    this.$sPopup.confirm(``, {
      title: this.$t('PopupTitle.confirmCreate'),
      message: this.$t('PopupBody.confirmCreate', { thing: `${i18n.tc('CreditNote.confirmCreateDialog')} ${this.invoice.number}` }),
      onConfirm: this.makeCreditNote,
    });
  }

  public redirectToCreated(data: GQL_createCreditNote) {
    const orders = data.createCreditNote?.orders || [];
    if (orders.length < 1) { this.$sMessage.error(this.$t('Message.somethingWentWrong')); return }

    if (orders.length > 1) {
      this.$router.push({
        name: 'Orders',
        query: { orderIds: orders.map(o => o.id) },
      }, () => {
        // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
        this.$sMessage.success(i18n.tc(
          'Message.savedCreditNote',
          orders.length,
          {
            invoiceNumber: this.invoice.number,
            orderNumbers: orders.map(o => o.number).join(', '),
          },
        ) as string,
        { duration: 0 });
      });
    } else {
      this.$router.push({
        name: 'OrdersEdit',
        params: { id: orders[0].id },
      }, () => {
        // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
        this.$sMessage.success(
          i18n.tc(
            'Message.savedCreditNote',
            orders.length,
            {
              invoiceNumber: this.invoice.number,
              orderNumbers: orders[0].number,
            }) as string,
          { duration: 10000 },
        );
      });
    }
  }
}
